import "./_hamburgers.scss";
import {weNavPanel1Open} from '../../../we-panels/we-nav-panels/we-nav-panel-1/we-nav-panel-1';
import {weNavPanel1Close} from '../../../we-panels/we-nav-panels/we-nav-panel-1/we-nav-panel-1';


$(function () {
	//HAM EVENTS
	$(".hamburger").click(function (e) {
		e.preventDefault();

		if ($(this).hasClass("xfy") == false) {
			$(this).addClass("xfy");
			weNavPanel1Open();
			$("html, body").animate(
				{
					scrollTop: 0,
				},
				400
			);
			$('body').addClass('we-bodyNoScroll');
		} else {
			$(this).removeClass("xfy");
			weNavPanel1Close();
			$("body").removeClass("we-bodyNoScroll");
		}
	});

	$(window).on("resize", function () {
		if (window.innerWidth >= 992) {
			weNavPanel1Close();
			$(".hamburger").removeClass("xfy");
			$("body").removeClass("we-bodyNoScroll");
		}
	});
	//END HAM EVENTS
});

import "./ham-1/ham-1";
